var map = {
	"./customization/container.svg": 86854,
	"./customization/dark.svg": 41093,
	"./customization/default.svg": 77496,
	"./customization/mini-menu.svg": 24296,
	"./customization/rtl.svg": 70253,
	"./customization/theme-color.svg": 66114,
	"./icons/gemini-color.svg": 32525,
	"./maintenance/Error404.png": 54333,
	"./maintenance/Error500.png": 96088,
	"./maintenance/TwoCone.png": 94912,
	"./maintenance/coming-soon.png": 10140,
	"./maintenance/under-construction.svg": 18451,
	"./users/avatar-1.png": 28505,
	"./users/avatar-10.png": 35037,
	"./users/avatar-2.png": 88770,
	"./users/avatar-3.png": 9899,
	"./users/avatar-4.png": 59988,
	"./users/avatar-5.png": 76669,
	"./users/avatar-6.png": 95462,
	"./users/avatar-7.png": 34479,
	"./users/avatar-8.png": 87147,
	"./users/avatar-9.png": 30657,
	"./whatsapp/chat-bg.jpg": 96014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13828;